export default __webpack_public_path__ + "static/media/charge_pump_positive_0_diodes.4a4b2a68.svg";